<template>
  <span style="background-color: #fff; border-top-right-radius: 15px;">
    <fieldset
      :class="cssClass"
      style="vertical-align: top;"
    >
      <legend :class="'ed_element_fieldset_legend ' + additionalLegendClass">{{ element.lang.title }}:</legend>
      <span
        v-for="(value, key) in element.settings.options"
        :key="value"
        class="ed_element_fieldset_label_wrapper"
        data-placement="bottom"
        data-toggle="tooltip"
        :title="value"
      >
        <input
          :id="'ed_element_fieldset_' + identifier + '_option_' + key + area.id"
          :checked="modelValue === key"
          class="ed_element_fieldset_radio_input"
          :name="'ed_element_fieldset_' + identifier + '_option_' + key + area.id"
          type="radio"
          :value="key"
          @input="processInput(key)"
        >
        <label
          :checked="modelValue === key"
          :class="'ed_element_fieldset_label ed_element_fieldset_label--' + key + ' ed_element_fieldset_label--' + value.toLowerCase()"
          :data-title="value"
          :for="'ed_element_fieldset_' + identifier + '_option_' + key + area.id"
        >
          <span class="sr-only">{{ value }}</span>
        </label>
      </span>
    </fieldset>
  </span>
</template>

<script>

/**
 * Die Komponente zur Darstellung der "Dropdown" CX Elemente (z.B. Hintergrundfarbe einstellen)
 * @displayName AppInputDropdown
 */
export default {
  name: 'AppInputDropdown',
  props: {
    trueElement: {
      type: Object,
      required: true
    },
    /**
     * Das konfigurierte Datenobjekt für das Feld das dargestellt werden soll
     */
    element: {
      type: Object,
      required: true
    },
    /**
     * Das konfigurierte Datenobjekt für das Feld das dargestellt werden soll
     */
    area: {
      type: Object,
      required: true
    },
    /**
     * Der Wert, den die Komponente darstellt. Via v-model einzuschläusen
     */
    modelValue: {
      type: String,
      required: true
    },
    additionalLegendClass: {
      type: String,
      default: ''
    },
    parentContent: {
      type: String,
      default: '{}'
    },
    identifier: {
      type: String,
      required: true
    }
  },
  emits: ['update:modelValue'],
  computed: {
    cssClass() {
      let string = 'ed_element_fieldset';

      if (   typeof this.element.settings !== 'undefined'
          && typeof this.element.settings.backend !== 'undefined'
          && typeof this.element.settings.backend.cssClass != 'undefined') {
        string += ' ' + this.element.settings.backend.cssClass;
      }

      return string
    }
  },
  watch: {
    element: {
      handler() {
        this.evaluateSelection();
      },
      deep: true,
    },
  },
  mounted() {
    this.evaluateSelection();
  },
  methods: {
    processInput(key) {
      this.$emit('update:modelValue', key);
      this.$store.commit('triggerSaveAll');
      this.$store.commit('stopEditing', this.trueElement.id);
    },
    isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    evaluateSelection() {
      // if there's no selection, we select the first
      if (   typeof this.modelValue == 'undefined'
        || (typeof this.modelValue !== 'undefined' && this.modelValue.length === 0)
      ) {
        // using selections made during area creation
        if (typeof this.element.identifier !== 'undefined' && this.isJson(this.parentContent)) {
          let content = JSON.parse(this.parentContent);
          let key = this.element.identifier.split('.').pop();

          if (Object.hasOwn(content, key)) {
            this.$store.commit('stopEditing', this.element.id);
            this.$emit('update:modelValue', content[key]);
            return
          }
        }

        let firstKey = Object.keys(this.element.settings.options)[0];
        this.$emit('update:modelValue', firstKey);
      }
    }
  }
}
</script>
